/**
 * @import {UserData} from '../user/model/user-data.js';
 * @import {ActionsliderAction} from './types.js';
 */
import angular from 'angular';
import {hasFeature} from 'acng/core/service/env';
import {getLocale} from 'acng/locale/model/locale.js';
import {getFallbackImageUrl} from 'acng/layout/service/fallback-image.js';
import {get} from 'acng/amateurPool/service/cache.js';
import {getBySetId} from '../moviePool/service/cache.js';
import {t} from '../locale/config/translate.js';
import {location} from 'nova';
import {all} from '@acng/frontend-bounty/std/control.js';

angular.module('actionslider', [])
  .factory('Actionslider', ['$rootScope', '$compile', 'sid', '$injector',
  /**
   * @param {angular.IRootScopeService} $rootScope
   * @param {angular.ICompileService} $compile
   * @param {string} sid
   * @param {angular.auto.IInjectorService} $injector
   */
  function ($rootScope, $compile, sid, $injector) {

    /** @type {import('acng/picturePool/factory/PictureSet').IPictureSetConstructor | null} */
    const PictureSet = hasFeature('picturePool') ? $injector.get('PictureSet') : null;
    const Livecams = hasFeature('livecam');

    /** @type {JQLite | null} */
    var as = null;
    /** @type {JQLite | null} */
    var aside = null;
    var scope = $rootScope.$new(false);

    /** @param {UserData} user */
    function create(user) {
      as = angular.element('<ons-actionslider>');

      as.attr('user-id', user.id)
        .attr('product-id', user.uid.split('-')[0])
        .attr('channels', user.partner_pool)
        .attr('on-click', 'onClick(action)')
        .attr('on-action', 'onAction(action)')
        .attr('action-session', sid)
        .attr('language', getLocale())
        .attr('on-scroll', 'onScroll(offset, children)');

      $compile(as)(scope);
    }

    /** @param {UserData} user */
    function display(user) {

      scope.onAction = onAction;
      scope.onScroll = onScroll;
      scope.onClick = onClick;

      if (!as) {
        create(user);
      }
      aside = angular.element('<aside>').append(as);
      angular.element('body').append(aside);
    }

    /** @param {ActionsliderAction} action */
    function onClick(action) {
      location.href = `${action.href}`;
    }

    /**
     * @param {ActionsliderAction} action
      * @returns {Promise<ActionsliderAction>}
     */
    async function onAction(action) {
      const [text, amateur] = await all([
        t('actionslider.' + action.id), //
        get(action.userId),
      ]);

      action.title = amateur.name;
      action.text = text;

      const base = `/sedcard/${amateur.nickname}`;

      switch (action.id) {
        case 'movies':
          if (!hasFeature('moviePool')) throw 'hidden movie feature';
          const movie = await getBySetId(Number(action.payload.setId));
          action.href = `${base}/movie/${movie.id}`;
          break;
        case 'pictures':
          if (!PictureSet) throw 'hidden picture feature';
          const pictureSet = await PictureSet.get(Number(action.payload.setId));
          action.href = `${base}/pictures/set/${pictureSet.id}`;
          break;
        case 'livecam':
          if (!Livecams) throw 'hidden livecam feature';
          action.href = base;
          break;
        case 'buddyrequest':
          if (!hasFeature('friend')) throw 'hidden friend feature';
          action.href = `/profile/friends/amateur_request`;
          break;
        case 'buddyconfirm':
          if (!hasFeature('friend')) throw 'hidden friend feature';
          action.href = base;
          break;
        case 'online':
          action.href = base;
          break;
        case 'weblog':
        default:
          throw `action "${action.id}" not supported`;
      }

      var img = new Image();
      img.onerror = function () {
        action.styles.backgroundImage = `url(${getFallbackImageUrl('160')})`;
      };
      img.onload = function () {
        action.styles.backgroundImage = `url(${img.src})`;
      };
      action.styles = action.styles || {};
      img.src = amateur.getImageUrl('small');

      return action;
    }

    /**
     * @param {number} offset
     * @param {{width?: number, height?: number}[]} children
     */
    function onScroll(offset, children) {

      var width = 0;

      if (offset !== 0) {
        width = children.slice(-offset).reduce(function (acc, val) {
          return acc + val.width;
        }, 0);
      }

      width += offset * 1; // because of margins

      return {
        transform: 'translate(' + width + 'px, 0)'
      };
    }

    function hide() {
      if (aside) {
        aside.hide();
      }
    }

    function show() {
      if (aside) {
        aside.show();
      }
    }

    return {
      display: display,
      hide: hide,
      show: show
    };

  }]);
